export default __webpack_public_path__ + "static/media/search_overlay.22c41199.png";